import { ESourceSystem } from '@if/core/types'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import { Chip, Grid, Link } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { useCurrentLang, useFinancingProgramEnum } from '../../../data/selectors/app-config-selectors'
import { PreviousApplication } from '../../../data/types/PreviousApplicationSchema'

interface Props {
  previousApplication: PreviousApplication[]
  label: string
}

const PreviousApplicationList = ({ previousApplication, label }: Props) => {
  const { t } = useTranslation()
  const lang = useCurrentLang()
  const financingProgramEnum = useFinancingProgramEnum()

  const renderLucasLink = (x: PreviousApplication) => {
    const isAlisOrMonolith = x.matchOn === ESourceSystem.Alis || x.matchOn === ESourceSystem.Monolith

    return (
      <div>
        {isAlisOrMonolith ? (
          <p style={{ marginRight: '10px' }}>
            {financingProgramEnum[x.financingProgramId][lang]} - #{x.referenceNumber} {x.merchantName}{' '}
          </p>
        ) : (
          <Link href={x.link} target="_blank" rel="noreferrer" style={{ marginRight: '10px' }}>
            {financingProgramEnum[x.financingProgramId][lang]} - #{x.referenceNumber} {x.merchantName}{' '}
          </Link>
        )}
      </div>
    )
  }

  return (
    <Grid container columnSpacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 12,
          lg: 12,
        }}
      >
        <Typography sx={{ width: '100%', textAlign: 'center' }}>{label}</Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 12,
          lg: 12,
        }}
      >
        {previousApplication.length > 0 ? (
          previousApplication.map((x) => (
            <div key={x.creditApplicationId}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {renderLucasLink(x)}
                <Chip
                  label={t(`common.otherApplication.${x.matchOn}`)}
                  variant="outlined"
                  style={{ marginRight: '5px' }}
                />
                {x.matchAsApplicant ? (
                  <Chip
                    label={t('common.otherApplication.asApplicant')}
                    variant="outlined"
                    style={{ marginRight: '5px' }}
                  />
                ) : (
                  <Chip
                    label={t('common.otherApplication.asCoApplicant')}
                    variant="outlined"
                    style={{ marginRight: '5px' }}
                  />
                )}
                <Chip
                  label={t(`ECreditApplicationStatus.${x.status}`, { ns: 'enum' })}
                  variant="outlined"
                  style={{ marginRight: '5px' }}
                />
                {x.hasAdditionalBankruptcies && <AccountBalanceIcon fontSize="medium" color="error" />}
              </div>
            </div>
          ))
        ) : (
          <p>{t('common.otherApplication.noApplication')}</p>
        )}
      </Grid>
    </Grid>
  )
}

export default PreviousApplicationList
